export default {
  meta: {
    title: '保护期管理', // 保护期管理
    url: '/expandstore/protectionperiod' // 埋点用，记录所属模块
  },
};
